import styled from "styled-components";

interface ColumnDivProps {
    gap?: string;
}

export const ColumnDiv = styled.div<ColumnDivProps>`
    display: flex;
    flex-direction: column;
    width: 100%;
    gap: ${(props: ColumnDivProps) => (props.gap ? props.gap : "16px")};
`;

interface RowDivProps {
    gap?: string;
}

export const RowDiv = styled.div<RowDivProps>`
    display: flex;
    width: 100%;
    gap: ${(props: RowDivProps) => (props.gap ? props.gap : "16px")};
`;
